var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container title-container"},[_c('div',{staticClass:"row"},[_c('span',{staticClass:"title-box"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('span',{staticClass:"message-background"},[_c('h2',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a42564","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = null
// module chunks = 